'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _styledComponents2.default.li.withConfig({
  componentId: 's1x35yig-0'
})(['display:inline-block;padding:15px 30px;position:relative;margin-right:5px;background:#f4f4f4;z-index:', ';margin-left:-5px;&:first-child{margin-left:0;}&::before{position:absolute;content:\'\';top:-1px;left:0;border-left:20px solid #fff;border-bottom:23.5px solid transparent;border-top:23.5px solid transparent;clear:both;}&::after{position:absolute;content:\'\';top:-1px;right:-19px;border-left:20px solid #f4f4f4;border-bottom:23.5px solid transparent;border-top:23.5px solid transparent;clear:both;}', ' ', ''], function (p) {
  return 11 - p.step;
}, function (p) {
  return p.step === 0 && '\n    &::before {\n      display: none;\n    }\n  ';
}, function (p) {
  return (p.done || p.active) && '\n    background: ' + p.theme.primaryColor + ';\n    color: #fff;\n  \n    &::after {\n      border-left: 20px solid ' + p.theme.primaryColor + ';\n    }\n  ';
});